export const ourCompanySelect = [
  {
    label: '武汉比耶传媒科技有限公司',
    value: 1
  },
  {
    label: '比耶传媒（武汉）有限公司',
    value: 2
  },
  {
    label: '武汉淳格传媒科技有限公司',
    value: 3
  },
  {
    label: '武汉群溯传媒科技有限公司',
    value: 4
  }
]
